/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const SliderDots = ({ status, className }) => {
  return <div className={`slider-dots ${status} ${className}`} />;
};

SliderDots.propTypes = {
  status: PropTypes.oneOf(["off", "on"]),
};
